const API_BASE_URL = "https://elorayem.com/stores";

const config = {
  API_BASE_URL,
  SITE_BASE_URL: API_BASE_URL.replace('/stores', '')
};

export default config;
